/**
 * Количество повторных запросов get_grouped_hotels, после которого поиск завершится по таймауту
 */
export const ERRORS_LIMIT = 3;
